"use client";
import { MotionProps, motion } from "framer-motion";
interface Props extends MotionProps {
  className?: string;
  once?: boolean;
}

const AnimatedElement = ({
  children,
  className,
  once = true,
  ...rest
}: Props) => {
  return (
    <motion.div className={className} viewport={{ once }} {...rest}>
      {children}
    </motion.div>
  );
};

export default AnimatedElement;
